import { t } from "ttag";

import {
  QueuedCreditAlert,
  ReferralCodeBanner,
} from "@/features/referral/components";
import { HowDoesItWorkModal } from "@/features/referral/sections";
import { REFERRAL_CREDIT_AMOUNT } from "@/shared/domains/referral";
import { useBoolean } from "@/shared/hooks";
import { Badge, Button, Card, GiftIcon } from "@/shared/ui";
import { ReferralDashboardModal } from "./referral-dashboard-modal";

export const ReferralProgramSection = () => {
  const {
    value: showDashboardModal,
    setTrue: openDashboardModal,
    setFalse: closeDashboardModal,
  } = useBoolean();

  const {
    value: showHowDoesItWorksModal,
    setTrue: openHowDoesItWorksModal,
    setFalse: closeHowDoesItWorksModal,
  } = useBoolean(false);

  return (
    <>
      <Card.Root className="gap-4">
        <Card.Header className="flex-col">
          <div className="flex items-center justify-between gap-2">
            <Card.Title icon={GiftIcon}>
              {t`Referral program`}

              <Badge
                size="x-small"
                color="light-primary"
                animated
                className="self-center"
              >
                {t`New!`}
              </Badge>
            </Card.Title>

            <Button
              size="lg"
              variant="tertiary"
              className="hidden p-0 underline md:block"
              onClick={openDashboardModal}
            >
              {t`Check your dashboard`}
            </Button>
          </div>

          <Card.Description className="text-base font-normal">
            {t`Give $${REFERRAL_CREDIT_AMOUNT}, get $${REFERRAL_CREDIT_AMOUNT}! Invite friends & family to join LevelsRx! See how it works`}{" "}
            <button
              onClick={openHowDoesItWorksModal}
              type="button"
              className="font-semibold underline"
            >
              {t`here`}
            </button>
            .
          </Card.Description>
        </Card.Header>

        <QueuedCreditAlert />

        <ReferralCodeBanner />

        <Card.Footer className="md:hidden">
          <Button
            size="lg"
            variant="secondary"
            className="w-full"
            onClick={openDashboardModal}
          >
            {t`Check your dashboard`}
          </Button>
        </Card.Footer>
      </Card.Root>

      <ReferralDashboardModal
        show={showDashboardModal}
        onClose={closeDashboardModal}
      />

      <HowDoesItWorkModal
        show={showHowDoesItWorksModal}
        onClose={closeHowDoesItWorksModal}
      />
    </>
  );
};
